import { Reveal } from "@/lib/motion";
import { IMAGES } from "@/lib/images";

const chapters = [
  {
    n: "01",
    title: "Bez diet cud i głodówek",
    body:
      "Zaczynamy od Ciebie — Twojego celu, możliwości i trybu życia. Układam trening tak, żeby dawał efekty i dało się go pogodzić z pracą, domem i codziennością.",
  },
  {
    n: "02",
    title: "Jeden na jeden, tylko Ty i trener",
    body:
      "Żadnego wstydu, żadnego tłumu. Trenujesz w swoim tempie, z pełną uwagą trenerki, która pilnuje techniki i motywuje wtedy, gdy najbardziej tego potrzebujesz.",
  },
  {
    n: "03",
    title: "Cel: znowu poczuć się sobą",
    body:
      "Ulubiona sukienka, która znów pasuje. Dwuczęściowy strój na plaży bez zastanawiania. Lekkość, energia i pewność siebie, którą widać każdego dnia.",
  },
];

export const Manifesto = () => (
  <section id="metoda" className="relative py-16 md:py-24">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B6B]">Metoda</span>
            <h2 className="font-display font-light text-4xl md:text-5xl mt-6 leading-tight">
              Trzy zasady, które zmieniają wszystko
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 relative overflow-hidden clip-frame h-80 hidden lg:block">
              <img
                src={IMAGES.manifesto}
                alt="Determinacja"
                className="w-full h-full object-cover grayscale hover:grayscale-0 hover:scale-105 transition-all duration-700"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8 lg:pl-10">
          <div className="space-y-px">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="group relative border-t border-[#2A2626] py-10 md:py-14 flex flex-col md:flex-row gap-6 md:gap-12">
                  <span className="font-display text-6xl md:text-8xl text-[#2A2626] group-hover:text-[#FF6B6B]/30 transition-colors duration-500 leading-none">
                    {c.n}
                  </span>
                  <div className="md:pt-3">
                    <h3 className="font-display text-3xl md:text-4xl text-[#F5F2F0]">{c.title}</h3>
                    <p className="mt-4 text-muted text-base md:text-lg leading-relaxed max-w-2xl">
                      {c.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
